import { useEffect } from "react";
import ReactGA from "react-ga4";
import { App } from "@capacitor/app";
import { useLocation, useNavigate } from "react-router-dom";
import { SafeArea } from "capacitor-plugin-safe-area";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

const PageTracker = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const applySafeArea = async () => {
    const { insets } = await SafeArea.getSafeAreaInsets();
    const top = insets?.top - 2 || 0;

    const root = document.getElementById("root");
    if (root) {
      root.style.transform = `translateY(${top}px)`;
      root.style.height = `calc(var(--vh) - ${top}px)`;

      document.documentElement.style.setProperty("--safe-area-top", `${top}px`);
    }

    const safeAreaTopEl = document.getElementById("safe-area-top");
    if (safeAreaTopEl) {
      safeAreaTopEl.style.height = `${top}px`;
    }
  };

  const changeStatusBarColor = async () => {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setBackgroundColor({ color: "#115774" });
    await StatusBar.setStyle({ style: Style.Dark });
  };

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      applySafeArea();
      changeStatusBarColor();
    }
  }, []);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const handleFirstInteraction = () => {
        changeStatusBarColor();

        document.removeEventListener("touchstart", handleFirstInteraction);
      };

      document.addEventListener("touchstart", handleFirstInteraction, {
        once: true,
      });

      return () => {
        document.removeEventListener("touchstart", handleFirstInteraction);
      };
    }
  }, []);

  useEffect(() => {
    App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        navigate(-1);
      } else {
        App.exitApp();
      }
    });

    return () => {
      App.removeAllListeners();
    };
  }, [navigate]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  return <></>;
};

export default PageTracker;
